import React from 'react'

const Footer = () => {
  return (
    <div className='block d-flex footerContainer'>
      <div className="left">
        <h1>JOBSFOUND :<span style={{color:"red"}}>)</span></h1>
      </div>
      <div className="right d-flex">
        <div className="one">
          <div className="head" style={{fontWeight: "700", marginBottom: "12px", fontSize:"25px"}}>For Candidate</div>
          <a href='/'><li className='footerLi'>Overview</li></a>
          <a href='/'><li className='footerLi'>Startup Jobs</li></a>
          <a href='/'><li className='footerLi'>Web3 Jobs</li></a>
          <a href='/'><li className='footerLi'>Featured</li></a>
          <a href='/'><li className='footerLi'>Salary Calculator</li></a>
          <a href='/'><li className='footerLi'>Remote Jobs</li></a>
          <a href='/'><li className='footerLi'>Tech Startups</li></a>
        </div>
        <div className="two">
          <div className="head" style={{fontWeight: "700", marginBottom: "12px", fontSize:"25px"}}>For Recruiter</div>
            <a href='/'><li className='footerLi'>Overview</li></a>
            <a href='/'><li className='footerLi'>Recruit Pro</li></a>
            <a href='/'><li className='footerLi'>Curated</li></a>
            <a href='/'><li className='footerLi'>Recruiter Cloud</li></a>
            <a href='/'><li className='footerLi'>Hire Developer</li></a>
            <a href='/'><li className='footerLi'>Pricing</li></a>
        </div>
        <div className="three">
          <div className="head" style={{fontWeight: "700", marginBottom: "12px", fontSize:"25px"}}>For Recruiter</div>
            <a href='/'><li className='footerLi'>About</li></a>
            <a href='/'><li className='footerLi'>Help</li></a>
            <a href='/'><li className='footerLi'>Terms and Risk</li></a>
            <a href='/'><li className='footerLi'>Blog</li></a>
            <a href='/'><li className='footerLi'>Privacy & Cookies</li></a>
            <a href='/'><li className='footerLi'>Venture</li></a>
        </div>
      </div>
    </div>
  )
}

export default Footer